// src/components/Sidebar.js

import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaCalendarPlus, FaListAlt } from 'react-icons/fa';
import styles from './Sidebar.module.css'; // We'll create this CSS file next

const Sidebar = () => {
  return (
    <aside className={styles.sidebar}>
      {/* <div className={styles.logo}>
        <img src="/path/to/your/logo.png" alt="Logo" />
      </div> */}
      <nav className={styles.nav}>
        <ul>
          <li>
            <NavLink to="/getmeeting" className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}>
              <FaListAlt className={styles.icon} />
              <span className={styles.text}>View Meetings</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/meeting" className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}>
              <FaCalendarPlus className={styles.icon} />
              <span className={styles.text}>Create Meeting</span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;